<template>
  <div>

    <h1>Aide</h1>
    
  </div>
</template>

<script>
export default {
  name: 'Aide',
}
</script>
